import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPEquipmentTypeTableDataAPI = createAsyncThunk("STPEquipmentTypeTableData", async ({ data }) => {
    const {
        M_STP_UnitTypeID,
        M_STP_EquipmentTypeID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_STP_EquipmentType_Select?M_STP_UnitTypeID=${M_STP_UnitTypeID ? M_STP_UnitTypeID : '0'}&M_STP_EquipmentTypeID=${M_STP_EquipmentTypeID ? M_STP_EquipmentTypeID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPEquipmentTypeTableDataSlice = createSlice({
    name: "STPEquipmentTypeTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEquipmentTypeTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEquipmentTypeTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEquipmentTypeTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPEquipmentTypeTableDataReducer = STPEquipmentTypeTableDataSlice.reducer


export const STPEquipmentTypePostDataAPI = createAsyncThunk("STPEquipmentTypePostData", async ({ data }) => {
    const {
        M_STP_EquipmentTypeID,
        M_STP_UnitTypeID,
        EquipmentType,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_STP_EquipmentTypeID", M_STP_EquipmentTypeID);
    formdata.append("M_STP_UnitTypeID", M_STP_UnitTypeID);
    formdata.append("EquipmentType", EquipmentType);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_STP_EquipmentType_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPEquipmentTypePostDataSlice = createSlice({
    name: "STPEquipmentTypePostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEquipmentTypePostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPEquipmentTypePostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPEquipmentTypePostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEquipmentTypePostDataReducer = STPEquipmentTypePostDataSlice.reducer

// -----------------Delete API ---------------

export const STPEquipmentTypeDeleteAPI = createAsyncThunk("STPEquipmentTypeDelete", async ({ data }) => {
    const {
        M_STP_EquipmentTypeID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_STP_EquipmentTypeID", M_STP_EquipmentTypeID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_STP_EquipmentType_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPEquipmentTypeDeleteSlice = createSlice({
    name: "STPEquipmentTypeDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPEquipmentTypeDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPEquipmentTypeDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPEquipmentTypeDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPEquipmentTypeDeleteReducer = STPEquipmentTypeDeleteSlice.reducer